import {index} from '../../api/endpoints/managerMoneyManagement'

export const state = {
  data: []
}

export const getters = {
  items(state) {
    return state.data
  }
}

export const mutations = {
  FETCH_DATA(state, payload) {
    state.data = payload.data
  }
}

export const actions = {
  fetchData({commit}) {
    return new Promise( (resolve, reject) => {
      index().then( res => {
        commit('FETCH_DATA', res.data);
        resolve(res)
      }).catch( err => {
        reject(err)
      })
    })
  }
}